import {Role} from '../models/role';
import {AuthService} from '../../login/services/auth.service';
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { User} from "../../shared/models/user";
import { UserService } from "../../shared/services/user.service";
import { SelectComponent } from 'ng-mdb-pro/pro';

@Component({
  selector: 'user-selector',
  templateUrl: './user-selector.component.html',
  styleUrls: ['./user-selector.component.css']
})
export class UserSelectorComponent implements OnInit, OnChanges  {
  @Output() selected = new EventEmitter<User>();
  @Input() allowEmpty:boolean;
  @Input() user:User;
  @Input() filter:(user:User) => boolean;

  @ViewChild("select") select:SelectComponent;

  public selectOptions:{label: string, value: string, selected: boolean}[];
  private users:User[];
  private _selectedUserId:string;

  constructor(private userService:UserService, private authService:AuthService) { 
    this.users = [];
  }

  ngOnInit() {
    this.authService.getCurrentUser().then(currentUser => {
      
      let getUsers = Promise.resolve([currentUser]);
      if (currentUser.role <= Role.Admin) {
        getUsers = this.userService.getUsers();
      }

      getUsers.then((users) => {
        let activeUsers = users.filter(u => u.enabled); // only display activated users.
        if (this.filter) {
          this.users = activeUsers.filter(this.filter);
        } else {
          this.users = activeUsers;
        }
        this.selectOptions = [{label: "None", value: null, selected: false}].concat(
          activeUsers.map(u => {
              let selected = this.user ? this.user.id == u.id : false;
              let result = {label: u.getDisplayName(), value: u.id, selected: selected};
              return result;
            })
        );
        // TODO: stephen I would rather use ngModel but none of that is working
        // we're going to bruteforce it for now.
        if (this.user) {
          this.select.select(this.user.id.toString());
        }
      });
    });

  }
  ngAfterContentInit() {
    
  }
  ngOnChanges() {
    
  }

  public get selectedUserId() {
    return this._selectedUserId;
  }

  public set selectedUserId(v:string) {
    this._selectedUserId = v;
  }

  public selectUser(selected:{label: string, value: string, selected: boolean}) {
    let intVal = +selected.value;
    let user = this.users.find(u => u.id == intVal);
    this.selected.emit(user);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/user-selector/user-selector.component.ts